import axios from 'axios'
import React, { useState } from 'react'
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

function Settings({serverUrl, titleOfPage, user, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();

    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                    <div className="container-fluid">
                        <div className="row">

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Settings